<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-start">
            <span class="me-2">{{ number }}. <span v-html="description"></span></span>
            <button class="btn btn-dark btn-sm" v-if="false" @click="openQuestionAnswerUpdateModal(question.id)">Update</button>
        </div>
        <div class="card-body">
            <ul class="list-group">
                <li v-for="(answer, ind) in question.answers" :key="'answer_'+ind" class="list-group-item"><span v-html="getAnswerContent(answer)"></span></li>
            </ul>
        </div>
    </div>

    <ConfirmationModal v-if="showQuestionAnswerModal" ref="updateQuestionAnswerModal" :title="modal_title_text" :info_text="modal_info_text" :icon_class="modal_icon_class" :btn_text="modal_btn_text" :btn_color="modal_btn_color" @close-modal="closeQuestionAnswerUpdateModal" @perform-action="updateQuestionAnswer"></ConfirmationModal>
</template>

<script setup>
import { computed, ref } from "vue";
import { useAuthStore } from "@/stores/auth-store.js";
import { useAppHelpers } from "@/composables/useAppHelpers.js";
import ConfirmationModal from '@/components/GenericModalAndViews/ConfirmationModal.vue';
import { useRouter } from "vue-router";
import apiClient from '@/utils/axios';

const props = defineProps({
    description: String,
    number: Number,
    question: Object,
    survey: Object
});
const auth = useAuthStore();
const router = useRouter();
const helper = useAppHelpers();

const modal_title_text = ref('');
const modal_info_text = ref('');
const modal_icon_class = ref('');
const modal_btn_text = ref('');
const modal_btn_color = ref('');

const updateQuestionAnswerModal = ref(null);
const showQuestionAnswerModal = ref(false);
const questionId = ref(null);

const getAnswerContent = (answer) => {
	if(props.question.questionType === 'SliderInput'){
		if(answer.text && answer.value){
			return answer.value + ' ' + answer.text + ''
		}
		else if(answer.text){
			return answer.text
		}
		else if(answer.value){
			return answer.value
		}
	}
	else{
		return answer.text ? answer.text : answer.value
	}
}

const allowedEditing = computed(() => {
	const notAllowedVariables = ['medication', 'condition_therapy',]
	if (
		(auth.is_member || auth.is_admin || auth.is_moderator) &&
		props.survey.user_id === auth.user.id &&
		props.survey.status !== 'processing' &&
		props.question &&
		!notAllowedVariables.includes(props.question.variable_name)
	) {
		return true;
	}
	return false;
});

const openQuestionAnswerUpdateModal = (id) => {
    questionId.value = id;
    modal_title_text.value = "Update Answer";
    modal_info_text.value = helper.gdprText() + "Do you want to update the answer to this question?";
    modal_btn_text.value = "Update Answer";
    modal_icon_class.value = "bi-pencil-square text-primary";
    modal_btn_color.value = 'btn-dark';
    showQuestionAnswerModal.value = true;
}
const closeQuestionAnswerUpdateModal = () => {
    questionId.value = null;
    modal_title_text.value = "";
    modal_info_text.value = "";
    modal_btn_text.value = "";
    modal_icon_class.value = "";
    modal_btn_color.value = '';
    showQuestionAnswerModal.value = false;
}
const updateQuestionAnswer = async () => {
    if (questionId.value && props.survey) {
        let url = "member/survey/update_survey/" + props.survey.id  + "/" + questionId.value;
        try {
            let response = await apiClient.post(url, {});
            if (response.status === 200) {
                localStorage.setItem('survey_id', this.specific_data.id);
                localStorage.setItem('survey_uid', this.specific_data.uuid);
                await router.push(
	                {
		                name: 'edit-survey-page',
		                params: {edit_id: this.specific_data.uuid, resume: 0,}
	                });
            }
            updateQuestionAnswerModal.value.close();
        }
        catch (error) {
            let errorObj = await useHttpErrorManager().handleError(error, false);
            updateQuestionAnswerModal.value.close();
        }
    }
    else {
        updateQuestionAnswerModal.value.close();
    }
}

</script>